import React, { useState, useEffect } from "react";
import AppDataTable from "./AppDataTable";
import { getAllSubcriptionPlain } from "../../interpreter/subcription";
import Icon from '@mdi/react';
import { mdiInformationOutline , mdiUpdate , mdiDeleteAlertOutline } from '@mdi/js';

export const SubscriptionList = ({ setSubscriptions, subscriptions, openModal }) => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                setLoading(true);
                const data = await getAllSubcriptionPlain();
                
                if (Array.isArray(data) && data.length > 0) {
                    setSubscriptions(data);
                } else {
                    setSubscriptions([]);
                }
            } catch (error) {
                console.error("Error al obtener las suscripciones:", error);
                setSubscriptions([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSubscriptions();
    }, [setSubscriptions]);

    const columns = [
        { name: "ID", selector: row => row.id, sortable: true, center: true, width: "80px" },
        { name: "Nombre", selector: row => row.name, sortable: true, center: true, width: "280px" },
        { name: "Código", selector: row => row.codeSubcription ?? "N/A", sortable: true, center: true, width: "120px" },
        { name: "Precio", selector: row => row.price ? `Bs${row.price}` : "N/A", sortable: true, center: true, width: "110px" },
        { name: "Estado", selector: row => row.status === '1' ? "Activo" : "Inactivo", sortable: true, center: true, width: "180px" },
        {
            name: "Acciones",
            cell: (row) => (
                <div className="flex flex-col sm:flex-row sm:space-x-2 space-y-2 sm:space-y-0 justify-center">
                    <button 
                        onClick={() => openModal('detail', row.id)} 
                        className="bg-blue-600 hover:bg-blue-400 text-white text-xs sm:text-sm py-2 px-3 rounded flex items-center justify-center gap-2 w-full"
                    >
                    <Icon path={mdiInformationOutline} size={1.3}/>
                    </button>
                    <button 
                        onClick={() => openModal('annular', row.id)} 
                        className="bg-red-600 hover:bg-red-400 text-white text-xs sm:text-sm py-2 px-3 rounded flex items-center justify-center gap-2 w-full"
                    >
                    <Icon path={mdiDeleteAlertOutline} size={1.3} />
                    </button>
                </div>
            ),
            center:true,
            width: "280px"
        },
    ];

    return (
        <div>
        {loading ? (
          // ✅ Spinner animado con Tailwind CSS (sin consumir recursos)
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid"></div>
          </div>
        ) : (
        <div className="w-full max-w-7xl overflow-x-auto max-h-[500px] overflow-y-auto transition-all duration-300">
          <AppDataTable
                columns={columns}
                data={Array.isArray(subscriptions) ? subscriptions : []}
                noDataComponent={<p className="text-gray-500 py-4">No hay suscripciones disponibles.</p>}
                customStyles={{
                    table: {
                        style: {
                            alignContent:"center",
                            width: "100%", // 
                            maxWidth: "30%", // 
                        },
                    },
                    headCells: {
                        style: {
                            fontWeight:"bolder",
                            textAlign: "center",
                            justifyContent: "center",
                            backgroundColor: "#f3f4f6",
                            borderBottom: "2px solid #ccc",
                            padding: "15px",
                            fontSize:"18px",
                        },
                    },
                    cells: {
                        style: {
                            textAlign: "center",
                            justifyContent: "center",
                            minHeight: "50px",
                            fontSize: "15px",
                            paddingTop: "6px",
                            paddingBottom: "6px",
                            borderBottom: "1px solid #ddd",
                            whiteSpace: "nowrap", // Evita que el contenido de las celdas se expanda innecesariamente
                            maxWidth: "250px", // Ajusta el ancho máximo de las celdas
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        },
                    },
                    rows: {
                        style: {
                            borderBottom: "1px solid #ddd",
                            "&:last-of-type": {
                                borderBottom: "none",
                            },
                        },
                    },
                }}
            />
        </div>
        )}
    </div>
    );
};
